<template>
  <div>
    <TitleBox v-model="selectedTab" :title="$t('title.leaderBoard')" :menus="menus" @change="fetchList" />
    <div class="g-container">
      <div class="g-box leader-board__list">
        <BoardItem v-for="(item, index) in list" :key="item.id" :target="item" :index="index" />
      </div>
    </div>
  </div>
</template>

<script>
import TitleBox from '@/components/TitleBox.vue';
import BoardItem from '@/views/LeaderBoard/BoardItem.vue';
import URLS from '@/config/url';

export default {
  name: 'LeaderBoard',
  components: { BoardItem, TitleBox },
  data() {
    return {
      list: [],
      selectedTab: 1,
      menus: [
        {
          label: this.$t('leaderBoard.applyBoard'),
          value: 1,
        },
        {
          label: this.$t('leaderBoard.submitBoard'),
          value: 2,
        },
      ],
    };
  },
  methods: {
    fetchList() {
      this.$request({
        url: URLS.rankList,
        params: {
          type: this.selectedTab,
          page_size: 20,
          page_number: 1,
        },
      }).then(({ result }) => {
        this.list = result;
      });
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss" scoped>
  .leader-board__list {
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>
